<div class="bgc-white rounded-18px p-4">
  <div class="">
    <div class="h1">
      <h1 class="fz-22px text-center">{{ 'otpVerify.pleaseVerify' | translate }}</h1>
      <p class="fz-12px text-center">{{ 'otpVerify.sentCode' | translate }}</p>
    </div>
    <div class="closeModal" (click)="closeOtpVerify();"></div>
    <div class="">
      <form (ngSubmit)="verifyOtp()" (keydown)="preventTrigger($event)" [formGroup]="otpForm" method="POST"
            action="/verifyOtp">
        <div class="bgc-link-water p-3 rounded-18px">
          <div class="step-container" (scroll)="onScroll($event);" [ngClass]="{'finished' : confStat === 'success'}">
            <div class="active">
              <div class="form-group position-relative">
                <label for="otp_code" class="color-lynch fw-600 fz-14px lh-lg ls-0_5 ms-1 tt-uppercase">{{ 'otpVerify.otpCode' | translate }}</label>
                <input [(ngModel)]="otpValueFromInput" autocomplete="one-time-code" *ngIf="otp" id="otp_code"
                       type="number" name="otp"
                       maxlength="4"
                       formControlName="otp"
                       (keydown)="checkOtpCharLength($event); refreshGoTo()"
                       (keyup)="toggleBtnAvailability($event)"
                       (change)="refreshGoTo();"
                       class="canDisableTooltip inputClass"
                       [ngClass]="{
                                        'error': otpInvalid || otp.invalid && otp.touched,
                                        'success': (otp.dirty || otp.touched) && otp.valid && this.otp.value.toString().length === 4
                                   }"/>
                <span class="validIcon"></span>
                <span class="d-block errorMessage fz-14px ms-1" *ngIf="otp.invalid && otp.touched">{{ 'otpVerify.digitsCountWarning' | translate }}</span>
              </div>
            </div>
          </div>
          <div class="jinniErrorBubble">
            <app-jinni-errors-messages [close]="close"></app-jinni-errors-messages>
          </div>
        </div>
        <div class="align-items-center d-flex flex-column justify-content-center mt-4">
          <button class="przycisk green big continueButton position-relative" type="{{buttonType}}" (click)="nextStep();"
                  [ngClass]="{
                                'active': (otp.valid),
                                'disabled-btn' : isLoadingButton || goTo === 'tryAgain' || holdButtonDisabled
                             }" >
            <span *ngIf="buttonType !== 'submit'">
              <span *ngIf="goTo !== 'tryAgain'">{{ 'otpVerify.send' | translate }}</span>
              <span *ngIf="goTo === 'tryAgain'">{{ 'freshRegistration.tryAgain' | translate }}</span>
            </span>
            <span *ngIf="buttonType === 'submit'">
              <span>{{ 'otpVerify.send' | translate }}</span>
            </span>
            <span *ngIf="isLoadingButton" class="spinner"></span>
          </button>
          <div class="align-items-center d-flex mt-3 resend-wrapper position-relative">
            <a href="#" class="fz-12px" (click)="resendCode($event)">{{ 'otpVerify.resend' | translate }}</a>
            <span *ngIf="greenSpinner" class="spinner-green square-20px"></span>
          </div>
        </div>
      </form>
    </div>

  </div>
</div>
